<div 
  class="reduction-badge"
  [ngClass]="[sizeClass, colorThemeClass, customColorClass]"
  [class.reduction-badge--disabled]="disabled"
  [class.reduction-badge--hidden]="!reduction"
  [ngStyle]="dynamicStyles"
  role="button" 
  tabindex="0"
  [attr.aria-label]="'Réduction de ' + reduction + ' pourcent'"
  [title]="'Réduction de ' + reduction + '%'"
  (click)="onReductionClick()"
  (keydown.enter)="onReductionClick()"
  (keydown.space)="onReductionClick()">
  
  <span class="reduction-badge__text" aria-hidden="true">
    {{ reductionValue }}
  </span>
  
  <span 
    *ngIf="showOffBadge" 
    class="reduction-badge__off-badge"
    aria-hidden="true">
    OFF
  </span>
</div>
